import classNames from "classnames";
import styles from './Input.module.scss'

type Props = {
  ref?: React.RefObject<HTMLInputElement>
} & React.InputHTMLAttributes<HTMLInputElement>

const Input = (props: Props) => {
  return <input {...props} className={classNames(styles.input, props.className)}/>
}

export default Input;